export const useFeatureFlag = (flagName: keyof ReturnType<typeof useRuntimeConfig>['public']['featureFlag']) => {
  const config = useRuntimeConfig()

  if (config.public.isReviewApp) {
    return true
  }

  return config.public.featureFlag[flagName]
}
